import React from 'react';

// Images
import VisaImage from 'Shared/images/CreditCardImages/visa-card.svg';
import AmexImage from 'Shared/images/CreditCardImages/amex-card.svg';
import MastercardImage from 'Shared/images/CreditCardImages/mastercard-card.svg';
import DiscoverImage from 'Shared/images/CreditCardImages/discover-card.svg';
import UnknownCardImage from 'Shared/images/CreditCardImages/unknown-card.svg';

// Styles
import './CreditCardDisplay.scss';

type Props = {
  brand: string;
  last4: string;
  expireMonth: number;
  expireYear: number;
};

const CreditCardDisplay = ({ brand, last4, expireMonth, expireYear }: Props) => {
  const getCardBrandImage = () => {
    switch (brand.toLowerCase()) {
      case 'visa':
        return VisaImage;
      case 'mastercard':
        return MastercardImage;
      case 'american express':
        return AmexImage;
      case 'discover':
        return DiscoverImage;
      default:
        return UnknownCardImage;
    }
  };

  const baseClassName = 'CreditCardDisplay';

  if (!brand || !last4) return null;

  return (
    <div className={baseClassName}>
      <img src={getCardBrandImage()} alt={brand} className={`${baseClassName}__image`} />
      <div className={`${baseClassName}__details`}>
        <div className={`${baseClassName}__details__number`}>
          <div className={`${baseClassName}__details__number__group`}>
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
          </div>
          <div className={`${baseClassName}__details__number__group`}>
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
          </div>
          <div className={`${baseClassName}__details__number__group`}>
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
            <span className={`${baseClassName}__details__number__group__dot`} />
          </div>
          <div className={`${baseClassName}__details__number__group`} data-test="billing-credit-card-last-four">
            {last4}
          </div>
        </div>
        <div className={`${baseClassName}__details__brand-expire`}>
          <span className={`${baseClassName}__details__brand-expire__brand`} data-test="billing-credit-card-brand">
            {brand}
          </span>
          <span>
            Exp.{' '}
            {expireMonth.toLocaleString('en-US', {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}
            /{expireYear}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CreditCardDisplay;
